import { QqBundleModel } from "../model/qq-bundle.model";
import { QqModel } from "../model/qq.model";
import { ControlsBundleMap } from "../message-interop/qq-state.type";

const _precompiledCache: { [key: string]: any } = {};

export class EquationProcessorService {
  constructor(
    private bundle: QqBundleModel,
    private controlsBundle: ControlsBundleMap,
    private currentOption: { [key: string]: string }
  ) {}

  isEquation(equation: string): boolean {
    switch (true) {
      case equation.startsWith("eval:"):
      case equation.startsWith("bundle:"):
        return true;
    }

    return false;
  }

  processEquation(qq: QqModel, equation: string): any {
    if (!equation) return false;

    switch (true) {
      case equation.startsWith("eval:"): {
        const operands = equation.replace("eval:", "");
        const funcText = `"use strict"; (${operands})`;
        let compiledFunc = undefined;

        if (_precompiledCache[funcText]) {
          compiledFunc = _precompiledCache[funcText];
        } else {
          // eslint-disable-next-line
          compiledFunc = eval(funcText);
          _precompiledCache[funcText] = compiledFunc;
        }

        return compiledFunc;
      }
      case equation.startsWith("bundle:"): {
        if (!this.controlsBundle[qq.key]) this.controlsBundle[qq.key] = {};
        if (!this.controlsBundle[qq.key][this.currentOption[qq.key]])
          this.controlsBundle[qq.key][this.currentOption[qq.key]] = [];

        let controlSet = equation.replace("bundle:", "");
        controlSet = controlSet.replace("[", "");
        controlSet = controlSet.replace("]", "");

        const arr = controlSet.split(",").map((x) => x.trim());

        arr.forEach((ctrl) => {
          if (
            !this.controlsBundle[qq.key][this.currentOption[qq.key]].includes(
              ctrl
            )
          )
            this.controlsBundle[qq.key][this.currentOption[qq.key]].push(ctrl);
        });

        return true;
      }

      default:
        return false;
    }
  }
}
